export class Brand {
    public image : string;
    public mimeType : string;

}
